"use client"

import { FileUser } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `FileUserIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const FileUserIcon = component(Icon)({ as: FileUser })
